import React from 'react';
import useStyle from './buttonWithText.style';
import { FlatIcon } from '../../Icons/FlatIcon';
import { Icon } from '../../Icons';
import { classNames } from '../../../../helpers/style/classNames';
import { ButtonVariant } from '../../../../types/button/buttonVariant.def';

export interface ButtonWithTextProps {
  variant?: ButtonVariant;
  iconColor?: string;
  content: string;
  icon?: Icon;
  onClick: (value?: any) => void;
  disabled?: boolean;
  loading?: boolean;
  iconPosition?: 'start' | 'end';
  iconSize?: 'small' | 'normal' | 'large';
}

export const ButtonWithText = ({
  variant = 'primaryGreen',
  iconColor,
  content,
  icon,
  onClick,
  disabled = false,
  loading = false,
  iconPosition = 'end',
  iconSize = 'normal'
}: ButtonWithTextProps) => {
  const classes = useStyle();

  return (
    <button
      onClick={!loading ? onClick : null}
      disabled={disabled}
      className={classNames(
        [classes.root, classes[variant]],
        [
          { condition: disabled, classe: classes.disabled },
          { condition: loading, classe: classes.loading },
          { condition: iconPosition === 'start', classe: classes.iconStart }
        ]
      )}
    >
      {!loading ? (
        <>
          {content}{' '}
          {icon && (
            <FlatIcon
              icon={icon}
              color={iconColor && iconColor}
              size={iconSize}
            />
          )}
        </>
      ) : (
        <>
          <div className={classes.loader}>
            <svg className={classes.svg} viewBox="0 0 80 80">
              <circle
                className={classNames([classes.svgContent, classes.circle])}
                id="test"
                cx="40"
                cy="40"
                r="32"
              ></circle>
            </svg>
          </div>
          <div className={classNames([classes.loader, classes.triangleLoader])}>
            <svg className={classes.svg} viewBox="0 0 86 80">
              <polygon
                className={classNames([classes.svgContent, classes.triangle])}
                points="43 8 79 72 7 72"
              ></polygon>
            </svg>
          </div>
          <div className={classes.loader}>
            <svg className={classes.svg} viewBox="0 0 80 80">
              <rect
                className={classNames([classes.svgContent, classes.rect])}
                x="8"
                y="8"
                width="64"
                height="64"
              ></rect>
            </svg>
          </div>
        </>
      )}
    </button>
  );
};
